import { render, staticRenderFns } from "./RupturaEstoque.vue?vue&type=template&id=3688da26&scoped=true"
import script from "./RupturaEstoque.vue?vue&type=script&lang=js"
export * from "./RupturaEstoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3688da26",
  null
  
)

export default component.exports